import React, { useState, useEffect } from 'react'
import InvoiceService from '../../../../../services/api/invoice.service'
import PatientService from '../../../../../services/api/patient.service'
import DimLoader from '../../../../templates/components/DimLoader'
import InvoicePreview from '../invoice-preview/InvoicePreview'
import APIResponse from '../../../../templates/components/APIResponse'

const SendInvoice = (props) => {
    const [email, setEmail] = useState()
    const [phone, setPhone] = useState()
    const [isLoader_PatientInfo, setIsLoader_PatientInfo] = useState(false)
    const [apiResponse, setApiResponse] = useState()
    const onSuccess = (message) => {
        if (props.refresh) {
            props.refresh()
        }
        if (props.onClose) {
            props.onClose()
        }
        if (props.exitHandler) {
            props.exitHandler()
        }
    }
    // const [patient, setPatient] = useState()
    const findPatient = () => {
        if (props.patientId || props.transaction.patientId) {
            let reqItem = props.patientId || props.transaction.patientId
            PatientService.getPatientById(reqItem)
                .then(res => {
                    console.log(res.data)
                    // setPatient(res.data)
                    if(res.data.email){
                        setEmail(res.data.email)
                    }
                    if(res.data.mobile){
                        setPhone(res.data.mobile)
                    }
                    if(res.data.phone){
                        setPhone(res.data.phone)
                    }
                })
                .catch(err=>{console.log(err)})
        }
    }
    const sendInvoiceHandler = () => {
        setIsLoader_PatientInfo(true)
        let reqObj = {
            emailId: email,
            phone: phone || null,
            providerId: props.transaction.providerId
        }
        InvoiceService.resendInvoice(props.invoiceId, reqObj)
            .then(res => {
                setIsLoader_PatientInfo(false)
               // console.log(res);
                setApiResponse(res);
            })
            .catch(err => {
                setIsLoader_PatientInfo(false)
                setApiResponse(err);
            })
    }
    useEffect(() => {
        if (props.transaction?.patientId || props.patientId) {
            findPatient()
        }
    }, [props.transaction?.patientId, props.patientId])
    return (
        <>
        <div className="row d-flex flex-wrap">
            { ![1,3,11,30].includes(props.transaction.invoiceStatus) && (<div className="col-lg-3 col-md-4 col-12 d-flex flex-column justify-content-between mb-3">
                <div className='col-12'>
                    <div className='card mb-3 p-3'>
                        <div className='field required'>
                            <label>Email</label>
                            <input type="text" placeholder={isLoader_PatientInfo?'Loading...':'Email'} value={email} onChange={e => { e.preventDefault(); setEmail(e.target.value) }} />
                        </div>
                    </div>
                    {/* <div className='card p-3'>
                        <div className='field'>
                            <label>Phone</label>
                            <InputMask mask='(999) 999-9999' type="text" placeholder={isLoader_PatientInfo?'Loading...':'Phone'}  value={phone} onChange={e => { e.preventDefault(); setPhone(e.target.value) }} />
                        </div>
                    </div> */}
                </div>
                <div className="mt-3 d-flex justify-content-between modal-button-bar">
                    <div className='col-auto'>
                        <button className="btn btn-primary" onClick={e => { e.preventDefault(); sendInvoiceHandler(); }}>Send</button>
                    </div>
                    <div className='col-auto'>
                        <button className="btn btn-secondary" onClick={e => { e.preventDefault(); props.onClose() }}>Cancel</button>
                    </div>
                </div>
                </div>
            )}
            <div className={props.transaction && ![1,3,11,30].includes(props.transaction.invoiceStatus) ? 'col-lg-9 col-md-8 col-12' : 'col-12'}>
                {props.transaction ? <InvoicePreview invoiceId={props.invoiceId || props.transaction.invoiceId} transaction={props.transaction} /> : <DimLoader />}
            </div>
        </div>
        <APIResponse apiResponse={apiResponse} onSuccess={onSuccess} toastOnSuccess={true} onClose={()=>props.onClose()} />
        </>
    )
}
export default SendInvoice